module.exports = __webpack_public_path__ + "static/media/031-dental insurance.8c41f0fe.svg";